module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_kimono@3x-015e9d207450134baf3bfaa757336404.webp";